import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/ai/AiImageBank/list",{
        params:{...params
        }
    })
}



export default {
    GET_LIST,

};
